<div *ngIf="!isLoading" class="label-container d-flex align-items-center flex-column">
    <div [ngClass]="isGeneric ? 'generic' : ''" class="label-avatar d-flex align-items-center justify-content-center">
        <img [ngClass]="isSvg ? 'label-img-svg' : 'label-img'" [lazyLoad]="avatarPath" [defaultImage]="'../../../assets/images/image-coming-soon.png'">
    </div>
    <div class="label-title">
        {{labelTitle}}
    </div>
</div>
<div *ngIf="isLoading" class="label-container d-flex align-items-center flex-column">
  <app-poshvine-skeleton-loader [component]="'plain-circle'"></app-poshvine-skeleton-loader>
</div>
